/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Area Restrita API
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ChangeMemberPasswordBody,
  GetMembershipsParams,
  InviteMembershipCommandBody,
  MembershipControllerGetMembershipsByTenantParams,
  MembershipQueryResponse,
  UpdateMembershipBody
} from '../../model';

import { instance } from '../../index';
import type { ErrorType, BodyType } from '../../index';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const membershipControllerGetMembershipsByTenant = (
    tenantId: string,
    params: MembershipControllerGetMembershipsByTenantParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<MembershipQueryResponse>(
      {url: `/api/v1/tenants/${tenantId}/memberships`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getMembershipControllerGetMembershipsByTenantQueryKey = (tenantId: string,
    params: MembershipControllerGetMembershipsByTenantParams,) => {
    return [`/api/v1/tenants/${tenantId}/memberships`, ...(params ? [params]: [])] as const;
    }

    
export const getMembershipControllerGetMembershipsByTenantInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, MembershipControllerGetMembershipsByTenantParams['page']>, TError = ErrorType<unknown>>(tenantId: string,
    params: MembershipControllerGetMembershipsByTenantParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, TError, TData, Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, QueryKey, MembershipControllerGetMembershipsByTenantParams['page']>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMembershipControllerGetMembershipsByTenantQueryKey(tenantId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, QueryKey, MembershipControllerGetMembershipsByTenantParams['page']> = ({ signal, pageParam }) => membershipControllerGetMembershipsByTenant(tenantId,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(tenantId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, TError, TData, Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, QueryKey, MembershipControllerGetMembershipsByTenantParams['page']> & { queryKey: DataTag<QueryKey, TData> }
}

export type MembershipControllerGetMembershipsByTenantInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>>
export type MembershipControllerGetMembershipsByTenantInfiniteQueryError = ErrorType<unknown>


export function useMembershipControllerGetMembershipsByTenantInfinite<TData = InfiniteData<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, MembershipControllerGetMembershipsByTenantParams['page']>, TError = ErrorType<unknown>>(
 tenantId: string,
    params: MembershipControllerGetMembershipsByTenantParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, TError, TData, Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, QueryKey, MembershipControllerGetMembershipsByTenantParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>,
          TError,
          Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMembershipControllerGetMembershipsByTenantInfinite<TData = InfiniteData<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, MembershipControllerGetMembershipsByTenantParams['page']>, TError = ErrorType<unknown>>(
 tenantId: string,
    params: MembershipControllerGetMembershipsByTenantParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, TError, TData, Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, QueryKey, MembershipControllerGetMembershipsByTenantParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>,
          TError,
          Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMembershipControllerGetMembershipsByTenantInfinite<TData = InfiniteData<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, MembershipControllerGetMembershipsByTenantParams['page']>, TError = ErrorType<unknown>>(
 tenantId: string,
    params: MembershipControllerGetMembershipsByTenantParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, TError, TData, Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, QueryKey, MembershipControllerGetMembershipsByTenantParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useMembershipControllerGetMembershipsByTenantInfinite<TData = InfiniteData<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, MembershipControllerGetMembershipsByTenantParams['page']>, TError = ErrorType<unknown>>(
 tenantId: string,
    params: MembershipControllerGetMembershipsByTenantParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, TError, TData, Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, QueryKey, MembershipControllerGetMembershipsByTenantParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getMembershipControllerGetMembershipsByTenantInfiniteQueryOptions(tenantId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getMembershipControllerGetMembershipsByTenantQueryOptions = <TData = Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, TError = ErrorType<unknown>>(tenantId: string,
    params: MembershipControllerGetMembershipsByTenantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMembershipControllerGetMembershipsByTenantQueryKey(tenantId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>> = ({ signal }) => membershipControllerGetMembershipsByTenant(tenantId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(tenantId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type MembershipControllerGetMembershipsByTenantQueryResult = NonNullable<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>>
export type MembershipControllerGetMembershipsByTenantQueryError = ErrorType<unknown>


export function useMembershipControllerGetMembershipsByTenant<TData = Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, TError = ErrorType<unknown>>(
 tenantId: string,
    params: MembershipControllerGetMembershipsByTenantParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>,
          TError,
          Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMembershipControllerGetMembershipsByTenant<TData = Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, TError = ErrorType<unknown>>(
 tenantId: string,
    params: MembershipControllerGetMembershipsByTenantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>,
          TError,
          Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMembershipControllerGetMembershipsByTenant<TData = Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, TError = ErrorType<unknown>>(
 tenantId: string,
    params: MembershipControllerGetMembershipsByTenantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useMembershipControllerGetMembershipsByTenant<TData = Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, TError = ErrorType<unknown>>(
 tenantId: string,
    params: MembershipControllerGetMembershipsByTenantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getMembershipControllerGetMembershipsByTenantQueryOptions(tenantId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getMembershipControllerGetMembershipsByTenantSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, TError = ErrorType<unknown>>(tenantId: string,
    params: MembershipControllerGetMembershipsByTenantParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMembershipControllerGetMembershipsByTenantQueryKey(tenantId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>> = ({ signal }) => membershipControllerGetMembershipsByTenant(tenantId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type MembershipControllerGetMembershipsByTenantSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>>
export type MembershipControllerGetMembershipsByTenantSuspenseQueryError = ErrorType<unknown>


export function useMembershipControllerGetMembershipsByTenantSuspense<TData = Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, TError = ErrorType<unknown>>(
 tenantId: string,
    params: MembershipControllerGetMembershipsByTenantParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMembershipControllerGetMembershipsByTenantSuspense<TData = Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, TError = ErrorType<unknown>>(
 tenantId: string,
    params: MembershipControllerGetMembershipsByTenantParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMembershipControllerGetMembershipsByTenantSuspense<TData = Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, TError = ErrorType<unknown>>(
 tenantId: string,
    params: MembershipControllerGetMembershipsByTenantParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useMembershipControllerGetMembershipsByTenantSuspense<TData = Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, TError = ErrorType<unknown>>(
 tenantId: string,
    params: MembershipControllerGetMembershipsByTenantParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof membershipControllerGetMembershipsByTenant>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getMembershipControllerGetMembershipsByTenantSuspenseQueryOptions(tenantId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const membershipControllerUpdateMembershipByTenant = (
    tenantId: string,
    userId: string,
    updateMembershipBody: BodyType<UpdateMembershipBody>,
 options?: SecondParameter<typeof instance>,) => {
      
      
      return instance<void>(
      {url: `/api/v1/tenants/${tenantId}/memberships/${userId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateMembershipBody
    },
      options);
    }
  


export const getMembershipControllerUpdateMembershipByTenantMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerUpdateMembershipByTenant>>, TError,{tenantId: string;userId: string;data: BodyType<UpdateMembershipBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof membershipControllerUpdateMembershipByTenant>>, TError,{tenantId: string;userId: string;data: BodyType<UpdateMembershipBody>}, TContext> => {
    
const mutationKey = ['membershipControllerUpdateMembershipByTenant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof membershipControllerUpdateMembershipByTenant>>, {tenantId: string;userId: string;data: BodyType<UpdateMembershipBody>}> = (props) => {
          const {tenantId,userId,data} = props ?? {};

          return  membershipControllerUpdateMembershipByTenant(tenantId,userId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MembershipControllerUpdateMembershipByTenantMutationResult = NonNullable<Awaited<ReturnType<typeof membershipControllerUpdateMembershipByTenant>>>
    export type MembershipControllerUpdateMembershipByTenantMutationBody = BodyType<UpdateMembershipBody>
    export type MembershipControllerUpdateMembershipByTenantMutationError = ErrorType<unknown>

    export const useMembershipControllerUpdateMembershipByTenant = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerUpdateMembershipByTenant>>, TError,{tenantId: string;userId: string;data: BodyType<UpdateMembershipBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof membershipControllerUpdateMembershipByTenant>>,
        TError,
        {tenantId: string;userId: string;data: BodyType<UpdateMembershipBody>},
        TContext
      > => {

      const mutationOptions = getMembershipControllerUpdateMembershipByTenantMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const membershipControllerInviteMembershipsByTenant = (
    tenantId: string,
    inviteMembershipCommandBody: BodyType<InviteMembershipCommandBody>,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<void>(
      {url: `/api/v1/tenants/${tenantId}/memberships/invite`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inviteMembershipCommandBody, signal
    },
      options);
    }
  


export const getMembershipControllerInviteMembershipsByTenantMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerInviteMembershipsByTenant>>, TError,{tenantId: string;data: BodyType<InviteMembershipCommandBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof membershipControllerInviteMembershipsByTenant>>, TError,{tenantId: string;data: BodyType<InviteMembershipCommandBody>}, TContext> => {
    
const mutationKey = ['membershipControllerInviteMembershipsByTenant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof membershipControllerInviteMembershipsByTenant>>, {tenantId: string;data: BodyType<InviteMembershipCommandBody>}> = (props) => {
          const {tenantId,data} = props ?? {};

          return  membershipControllerInviteMembershipsByTenant(tenantId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MembershipControllerInviteMembershipsByTenantMutationResult = NonNullable<Awaited<ReturnType<typeof membershipControllerInviteMembershipsByTenant>>>
    export type MembershipControllerInviteMembershipsByTenantMutationBody = BodyType<InviteMembershipCommandBody>
    export type MembershipControllerInviteMembershipsByTenantMutationError = ErrorType<unknown>

    export const useMembershipControllerInviteMembershipsByTenant = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof membershipControllerInviteMembershipsByTenant>>, TError,{tenantId: string;data: BodyType<InviteMembershipCommandBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof membershipControllerInviteMembershipsByTenant>>,
        TError,
        {tenantId: string;data: BodyType<InviteMembershipCommandBody>},
        TContext
      > => {

      const mutationOptions = getMembershipControllerInviteMembershipsByTenantMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const changeMemberPasswordByTenant = (
    tenantId: string,
    userId: string,
    changeMemberPasswordBody: BodyType<ChangeMemberPasswordBody>,
 options?: SecondParameter<typeof instance>,) => {
      
      
      return instance<void>(
      {url: `/api/v1/tenants/${tenantId}/memberships/${userId}/change-password`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: changeMemberPasswordBody
    },
      options);
    }
  


export const getChangeMemberPasswordByTenantMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeMemberPasswordByTenant>>, TError,{tenantId: string;userId: string;data: BodyType<ChangeMemberPasswordBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof changeMemberPasswordByTenant>>, TError,{tenantId: string;userId: string;data: BodyType<ChangeMemberPasswordBody>}, TContext> => {
    
const mutationKey = ['changeMemberPasswordByTenant'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeMemberPasswordByTenant>>, {tenantId: string;userId: string;data: BodyType<ChangeMemberPasswordBody>}> = (props) => {
          const {tenantId,userId,data} = props ?? {};

          return  changeMemberPasswordByTenant(tenantId,userId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangeMemberPasswordByTenantMutationResult = NonNullable<Awaited<ReturnType<typeof changeMemberPasswordByTenant>>>
    export type ChangeMemberPasswordByTenantMutationBody = BodyType<ChangeMemberPasswordBody>
    export type ChangeMemberPasswordByTenantMutationError = ErrorType<unknown>

    export const useChangeMemberPasswordByTenant = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeMemberPasswordByTenant>>, TError,{tenantId: string;userId: string;data: BodyType<ChangeMemberPasswordBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof changeMemberPasswordByTenant>>,
        TError,
        {tenantId: string;userId: string;data: BodyType<ChangeMemberPasswordBody>},
        TContext
      > => {

      const mutationOptions = getChangeMemberPasswordByTenantMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getMemberships = (
    params: GetMembershipsParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<MembershipQueryResponse>(
      {url: `/api/v1/memberships`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetMembershipsQueryKey = (params: GetMembershipsParams,) => {
    return [`/api/v1/memberships`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMembershipsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getMemberships>>, GetMembershipsParams['page']>, TError = ErrorType<unknown>>(params: GetMembershipsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMemberships>>, TError, TData, Awaited<ReturnType<typeof getMemberships>>, QueryKey, GetMembershipsParams['page']>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMembershipsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMemberships>>, QueryKey, GetMembershipsParams['page']> = ({ signal, pageParam }) => getMemberships({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMemberships>>, TError, TData, Awaited<ReturnType<typeof getMemberships>>, QueryKey, GetMembershipsParams['page']> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMembershipsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getMemberships>>>
export type GetMembershipsInfiniteQueryError = ErrorType<unknown>


export function useGetMembershipsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMemberships>>, GetMembershipsParams['page']>, TError = ErrorType<unknown>>(
 params: GetMembershipsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMemberships>>, TError, TData, Awaited<ReturnType<typeof getMemberships>>, QueryKey, GetMembershipsParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberships>>,
          TError,
          Awaited<ReturnType<typeof getMemberships>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMembershipsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMemberships>>, GetMembershipsParams['page']>, TError = ErrorType<unknown>>(
 params: GetMembershipsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMemberships>>, TError, TData, Awaited<ReturnType<typeof getMemberships>>, QueryKey, GetMembershipsParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberships>>,
          TError,
          Awaited<ReturnType<typeof getMemberships>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMembershipsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMemberships>>, GetMembershipsParams['page']>, TError = ErrorType<unknown>>(
 params: GetMembershipsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMemberships>>, TError, TData, Awaited<ReturnType<typeof getMemberships>>, QueryKey, GetMembershipsParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetMembershipsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMemberships>>, GetMembershipsParams['page']>, TError = ErrorType<unknown>>(
 params: GetMembershipsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMemberships>>, TError, TData, Awaited<ReturnType<typeof getMemberships>>, QueryKey, GetMembershipsParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMembershipsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetMembershipsQueryOptions = <TData = Awaited<ReturnType<typeof getMemberships>>, TError = ErrorType<unknown>>(params: GetMembershipsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberships>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMembershipsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMemberships>>> = ({ signal }) => getMemberships(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMemberships>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMembershipsQueryResult = NonNullable<Awaited<ReturnType<typeof getMemberships>>>
export type GetMembershipsQueryError = ErrorType<unknown>


export function useGetMemberships<TData = Awaited<ReturnType<typeof getMemberships>>, TError = ErrorType<unknown>>(
 params: GetMembershipsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberships>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberships>>,
          TError,
          Awaited<ReturnType<typeof getMemberships>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMemberships<TData = Awaited<ReturnType<typeof getMemberships>>, TError = ErrorType<unknown>>(
 params: GetMembershipsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberships>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemberships>>,
          TError,
          Awaited<ReturnType<typeof getMemberships>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMemberships<TData = Awaited<ReturnType<typeof getMemberships>>, TError = ErrorType<unknown>>(
 params: GetMembershipsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberships>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetMemberships<TData = Awaited<ReturnType<typeof getMemberships>>, TError = ErrorType<unknown>>(
 params: GetMembershipsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemberships>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMembershipsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetMembershipsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMemberships>>, TError = ErrorType<unknown>>(params: GetMembershipsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMemberships>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMembershipsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMemberships>>> = ({ signal }) => getMemberships(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMemberships>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMembershipsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMemberships>>>
export type GetMembershipsSuspenseQueryError = ErrorType<unknown>


export function useGetMembershipsSuspense<TData = Awaited<ReturnType<typeof getMemberships>>, TError = ErrorType<unknown>>(
 params: GetMembershipsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMemberships>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMembershipsSuspense<TData = Awaited<ReturnType<typeof getMemberships>>, TError = ErrorType<unknown>>(
 params: GetMembershipsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMemberships>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMembershipsSuspense<TData = Awaited<ReturnType<typeof getMemberships>>, TError = ErrorType<unknown>>(
 params: GetMembershipsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMemberships>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetMembershipsSuspense<TData = Awaited<ReturnType<typeof getMemberships>>, TError = ErrorType<unknown>>(
 params: GetMembershipsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMemberships>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMembershipsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const updateMembership = (
    userId: string,
    updateMembershipBody: BodyType<UpdateMembershipBody>,
 options?: SecondParameter<typeof instance>,) => {
      
      
      return instance<void>(
      {url: `/api/v1/memberships/${userId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateMembershipBody
    },
      options);
    }
  


export const getUpdateMembershipMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMembership>>, TError,{userId: string;data: BodyType<UpdateMembershipBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMembership>>, TError,{userId: string;data: BodyType<UpdateMembershipBody>}, TContext> => {
    
const mutationKey = ['updateMembership'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMembership>>, {userId: string;data: BodyType<UpdateMembershipBody>}> = (props) => {
          const {userId,data} = props ?? {};

          return  updateMembership(userId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateMembershipMutationResult = NonNullable<Awaited<ReturnType<typeof updateMembership>>>
    export type UpdateMembershipMutationBody = BodyType<UpdateMembershipBody>
    export type UpdateMembershipMutationError = ErrorType<unknown>

    export const useUpdateMembership = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMembership>>, TError,{userId: string;data: BodyType<UpdateMembershipBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateMembership>>,
        TError,
        {userId: string;data: BodyType<UpdateMembershipBody>},
        TContext
      > => {

      const mutationOptions = getUpdateMembershipMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const inviteMember = (
    inviteMembershipCommandBody: BodyType<InviteMembershipCommandBody>,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<void>(
      {url: `/api/v1/memberships/invite`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inviteMembershipCommandBody, signal
    },
      options);
    }
  


export const getInviteMemberMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteMember>>, TError,{data: BodyType<InviteMembershipCommandBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof inviteMember>>, TError,{data: BodyType<InviteMembershipCommandBody>}, TContext> => {
    
const mutationKey = ['inviteMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inviteMember>>, {data: BodyType<InviteMembershipCommandBody>}> = (props) => {
          const {data} = props ?? {};

          return  inviteMember(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InviteMemberMutationResult = NonNullable<Awaited<ReturnType<typeof inviteMember>>>
    export type InviteMemberMutationBody = BodyType<InviteMembershipCommandBody>
    export type InviteMemberMutationError = ErrorType<unknown>

    export const useInviteMember = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteMember>>, TError,{data: BodyType<InviteMembershipCommandBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof inviteMember>>,
        TError,
        {data: BodyType<InviteMembershipCommandBody>},
        TContext
      > => {

      const mutationOptions = getInviteMemberMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const changeMemberPassword = (
    userId: string,
    changeMemberPasswordBody: BodyType<ChangeMemberPasswordBody>,
 options?: SecondParameter<typeof instance>,) => {
      
      
      return instance<void>(
      {url: `/api/v1/memberships/${userId}/change-password`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: changeMemberPasswordBody
    },
      options);
    }
  


export const getChangeMemberPasswordMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeMemberPassword>>, TError,{userId: string;data: BodyType<ChangeMemberPasswordBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof changeMemberPassword>>, TError,{userId: string;data: BodyType<ChangeMemberPasswordBody>}, TContext> => {
    
const mutationKey = ['changeMemberPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeMemberPassword>>, {userId: string;data: BodyType<ChangeMemberPasswordBody>}> = (props) => {
          const {userId,data} = props ?? {};

          return  changeMemberPassword(userId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangeMemberPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof changeMemberPassword>>>
    export type ChangeMemberPasswordMutationBody = BodyType<ChangeMemberPasswordBody>
    export type ChangeMemberPasswordMutationError = ErrorType<unknown>

    export const useChangeMemberPassword = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeMemberPassword>>, TError,{userId: string;data: BodyType<ChangeMemberPasswordBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof changeMemberPassword>>,
        TError,
        {userId: string;data: BodyType<ChangeMemberPasswordBody>},
        TContext
      > => {

      const mutationOptions = getChangeMemberPasswordMutationOptions(options);

      return useMutation(mutationOptions);
    }
    